
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai-automation-guide-for-small-business",
      function () {
        return require("private-next-pages/ai-automation-guide-for-small-business.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai-automation-guide-for-small-business"])
      });
    }
  